import { render, staticRenderFns } from "./TenderingBell.vue?vue&type=template&id=b06ddaf8&"
import script from "./TenderingBell.vue?vue&type=script&lang=js&"
export * from "./TenderingBell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports